import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';

function useImageLoaded(_ref) {
  var src = _ref.src,
    srcSet = _ref.srcSet;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  useEffect(function () {
    var active = false;
    if (src) {
      setLoaded({
        state: false
      });
      active = true;
      var image = new Image();
      image.src = src;
      if (srcSet) {
        image.srcset = srcSet;
      }
      image.onload = function () {
        if (active) {
          setLoaded({
            state: 'loaded',
            size: {
              width: image.width,
              height: image.height
            }
          });
        }
      };
      image.onerror = function () {
        if (active) {
          setLoaded({
            state: 'error'
          });
        }
      };
    }
    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}

export { useImageLoaded };
//# sourceMappingURL=use-image-loaded.esm.js.map
